import { Button } from "@/components/ui/button";
import { EtapasCompraRapida } from "..";
import { BuscarClientePorCPFDTO } from "@/services/CompraRapidaService";
import { conformToMask } from "react-text-mask";
import { MASCARA_CPF, MASCARA_TELEFONE } from "@/utils/Constants";
import { labelPlural } from "@/utils/copyTituloBilhete";


export interface EtapaResumoProps {
    alterarEtapa: (etapa: EtapasCompraRapida) => void,
    handleLoginEFinalizarCompra: () => void
    formik: any,
    alterarUsuario: (usuario?: BuscarClientePorCPFDTO) => void,
    usuario: BuscarClientePorCPFDTO,
    quantidade: number,
    finalizandoCompra: boolean,
}

export function EtapaResumo({ finalizandoCompra, quantidade, formik, alterarUsuario, alterarEtapa, handleLoginEFinalizarCompra }: EtapaResumoProps) {

    function maskCPF(cpf: string): string {
        return cpf.replace(/^(\d{3})\.(\d{3})\.(\d{3})-(\d{2})$/, '***.$2.***-$4');
    }

    function maskTelefone(telefone: string): string {
        return telefone.replace(
            /^(\(\d{2}\))\s*(\d{1,2})\d{3,4}-(\d{2})(\d{2})$/,
            '$1 $2***-**$4'
        );
    }

    function maskFullName(name: string): string {
        const parts = name.split(' ');

        return parts
            .map((part, index) => {
                if (index === 0) {
                    // Garante que ao menos 1 caractere fique visível
                    const visiblePart = part.slice(0, Math.min(4, part.length));
                    return visiblePart + '*'.repeat(Math.max(0, part.length - visiblePart.length));
                } else if (index === parts.length - 1) {
                    // Mantém ao menos os dois primeiros e dois últimos caracteres, se houver espaço
                    if (part.length > 4) {
                        return part.slice(0, 2) + '*'.repeat(part.length - 4) + part.slice(-2);
                    }
                    return '*'.repeat(part.length);
                } else {
                    return '*'.repeat(part.length);
                }
            })
            .join(' ');
    }

    return (
        <>
            <div className="flex flex-col">
                <h1 className="text-center text-primary font-semibold text-xl">
                    Resumo da Compra
                </h1>
                <div className="mt-4">
                    <p><span className="font-semibold">Nome:</span> {maskFullName(formik.values.Nome)}</p>
                    <p><span className="font-semibold">CPF:</span> {maskCPF(conformToMask(formik.values.CPF, MASCARA_CPF).conformedValue)}</p>
                    <p><span className="font-semibold">Telefone:</span> {maskTelefone(conformToMask(formik.values.Telefone, MASCARA_TELEFONE).conformedValue)}</p>
                    <p><span className="font-semibold">Total de {labelPlural()}:</span> {quantidade}</p>
                </div>

                <div className="flex justify-center gap-2 mt-5">
                    <Button
                        disabled={finalizandoCompra}
                        type="button"
                        onClick={() => {
                            alterarEtapa(EtapasCompraRapida.SelecionarQuantidade)
                            alterarUsuario(undefined)
                            formik.resetForm();
                        }}
                        variant="foreground"
                        className="mt-2">
                        Voltar
                    </Button>
                    <Button
                        disabled={finalizandoCompra}
                        type="button"
                        onClick={handleLoginEFinalizarCompra}
                        variant="foreground"
                        className="mt-2">

                        {
                            finalizandoCompra ? 'Gerando QRCode...' : 'Comprar com PIX'
                        }
                    </Button>
                </div>
            </div>
        </>
    )
}